import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { FormattedText, Typography } from "client/Components";
import { isNotNilOrEmpty, setTrackingId } from "client/Misc/utils";
import { InlineIcon } from "./InlineIcon/InlineIcon";
import { CommunityPostCommentNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { getComputedDisplayName } from "client/Features/AddressBook/common";
import { preparePostTitleAndComment } from "./CommunityPostActivity";

export type CommunityPostCommentActivityProps = {
	data: CommunityPostCommentNotificationDataViewModel;
};

export const CommunityPostCommentActivity = (props: CommunityPostCommentActivityProps): ReactElement => {
	const { data } = props;

	const {
		postMessagePreview,
		firstname,
		lastname,
	} = data;

	const preparedPostTitleAndComment: string = preparePostTitleAndComment(postMessagePreview ?? "");

	const { computedDisplayName } = getComputedDisplayName({
		firstName: firstname,
		lastName: lastname
	});

	return (
		<span>
			<InlineIcon icon="comment" />
			<span {...setTrackingId("title")}>
				<FormattedText
					text={
						localize(
							isNotNilOrEmpty(preparedPostTitleAndComment)
								? "_UserXCommentedOnPostTitleY"
								: "_UserXCommentedOnAPost"
						)
					}
					thingsToReplace={[
						{
							what: "{{Username}}",
							filler: (
								<Typography
									trackingId="name"
									weight="bold"
								>
									{computedDisplayName}
								</Typography>
							)
						},
						{
							what: "{{Post}}",
							filler: (
								<Typography
									weight="bold"
									trackingId="message"
								>
									{preparedPostTitleAndComment}
								</Typography>
							)
						}
					]}
				/>
			</span>
		</span>
	);
};

CommunityPostCommentActivity.displayName = "CommunityPostCommentActivity";